module.exports = __webpack_public_path__ + "img/banner1.bf5a5658.jpg";